<template>
<div class="wenhui-tech-terms">
    <!-- 科技感Banner -->
    <div class="tech-terms-banner">
        <div class="banner-content">
            <h1>服务条款</h1>
            <p>使用前请仔细阅读以下协议</p>
            <div class="tech-particles">
                <div class="particle" v-for="i in 20" :key="i" :style="{
                    left: `${Math.random()*100}%`,
                    top: `${Math.random()*100}%`,
                    animationDelay: `${Math.random()*2}s`
                }"></div>
            </div>
        </div>
    </div>

    <!-- 条款内容区域 -->
    <div class="section tech-terms-section">
        <div class="container">
            <el-card class="tech-terms-card">
                <div class="terms-content">
                    <h2 class="section-title">服务<span class="tech-highlight">条款</span></h2>
                    <p class="section-subtitle">最后更新日期：2025年1月15日</p>

                    <div class="terms-article">
                        <h3>1. 接受条款</h3>
                        <p>通过访问或使用[您的公司/平台名称]（以下简称"本平台"）提供的服务，您同意遵守本《服务条款》（以下简称"条款"）。如果您不同意这些条款，请不要使用我们的服务。</p>

                        <h3>2. 服务描述</h3>
                        <p>本平台通过[网站/应用程序]提供以下服务：[简要描述核心服务]。我们保留随时修改或终止服务的权利，恕不另行通知。</p>

                        <h3>3. 用户资格</h3>
                        <p>您必须年满18周岁或所在司法管辖区的法定成年年龄才能使用本服务。代表企业使用时，您需保证已获得合法授权。</p>

                        <h3>4. 账户责任</h3>
                        <p>您有责任维护账户信息的机密性，并对账户下的所有活动负责。如发现任何未授权使用，请立即通知我们。</p>

                        <h3>5. 用户行为准则</h3>
                        <p>您同意不从事以下行为：</p>
                        <ul>
                            <li>发布违法、侵权或不当内容</li>
                            <li>干扰服务正常运行</li>
                            <li>侵犯他人知识产权</li>
                            <li>从事欺诈或虚假活动</li>
                        </ul>

                        <h3>6. 知识产权</h3>
                        <p>本平台所有内容（包括但不限于文字、图形、商标、代码）均受相关法律保护。未经书面许可，不得复制、修改或商业化使用。</p>

                        <h3>7. 免责声明</h3>
                        <p>本服务按"现状"提供，不承诺无中断或完全无错误。在法律允许范围内，我们对因使用服务导致的间接损失不承担责任。</p>

                        <h3>8. 隐私政策</h3>
                        <p>您的个人信息处理受《隐私政策》约束，请参阅<a href="/privacy" class="tech-link">隐私政策页面</a>。</p>

                        <h3>9. 修改与终止</h3>
                        <p>我们保留随时修改本条款的权利。修改后的条款将在发布后生效。继续使用服务即视为接受更新。</p>

                        <h3>10. 法律适用</h3>
                        <p>本条款受中华人民共和国法律管辖。争议应优先通过友好协商解决；协商不成，提交[指定仲裁机构或法院]解决。</p>

                        <div class="terms-accept">
                            <el-checkbox v-model="accepted">我已阅读并同意上述服务条款</el-checkbox>
                            <el-button type="primary" round class="tech-confirm-btn" :disabled="!accepted">
                                确认接受
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'WenhuiTechTerms',
    data() {
        return {
            accepted: false
        }
    }
}
</script>

<style lang="scss" scoped>
.wenhui-tech-terms {
    padding-top: 80px;
    background-color: #f5f7fa;

    .tech-terms-banner {
        height: 400px;
        background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #fff;
        position: relative;
        overflow: hidden;

        .banner-content {
            position: relative;
            z-index: 2;

            h1 {
                font-size: 60px;
                margin: 0 0 15px;
                font-weight: 700;
                text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            }

            p {
                font-size: 24px;
                margin: 0;
                opacity: 0.9;
            }
        }

        .tech-particles {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;

            .particle {
                position: absolute;
                width: 3px;
                height: 3px;
                background: rgba(255, 255, 255, 0.7);
                border-radius: 50%;
                animation: float 5s infinite ease-in-out;
                opacity: 0.7;
            }
        }
    }

    .section {
        padding: 60px 0;

        &.tech-terms-section {
            background-color: #f5f7fa;
        }
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .tech-terms-card {
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        margin-bottom: 40px;
        border: none;

        /deep/ .el-card__body {
            padding: 50px;
        }
    }

    .section-title {
        text-align: center;
        font-size: 42px;
        color: #333;
        margin-bottom: 15px;
        position: relative;
        font-weight: 700;

        .tech-highlight {
            color: #409EFF;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: 5px;
                left: 0;
                width: 100%;
                height: 10px;
                background: rgba(64, 158, 255, 0.2);
                z-index: -1;
            }
        }
    }

    .section-subtitle {
        text-align: center;
        font-size: 18px;
        color: #666;
        margin-bottom: 50px;
    }

    .terms-article {
        max-width: 900px;
        margin: 0 auto;
        color: #444;
        line-height: 1.8;

        h3 {
            color: #333;
            font-size: 22px;
            margin: 40px 0 15px;
            font-weight: 600;
            position: relative;
            padding-left: 15px;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 8px;
                height: 18px;
                width: 5px;
                background: #409EFF;
                border-radius: 3px;
            }
        }

        p,
        ul {
            margin-bottom: 20px;
            font-size: 16px;
        }

        ul {
            padding-left: 25px;

            li {
                margin-bottom: 10px;
            }
        }

        .tech-link {
            color: #409EFF;
            text-decoration: none;
            transition: all 0.3s;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .terms-accept {
        margin-top: 60px;
        padding-top: 30px;
        border-top: 1px solid #eee;
        text-align: center;

        /deep/ .el-checkbox {
            display: block;
            margin-bottom: 20px;

            .el-checkbox__label {
                font-size: 16px;
                color: #666;
            }
        }

        .tech-confirm-btn {
            width: 200px;
            height: 50px;
            font-size: 16px;
            transition: all 0.3s;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
            }

            &:disabled {
                opacity: 0.6;
                transform: none !important;
                box-shadow: none !important;
            }
        }
    }

    @media (max-width: 992px) {
        .tech-terms-banner {
            height: 350px;

            h1 {
                font-size: 48px;
            }

            p {
                font-size: 20px;
            }
        }

        .tech-terms-card /deep/ .el-card__body {
            padding: 40px 30px;
        }
    }

    @media (max-width: 768px) {
        .tech-terms-banner {
            height: 300px;

            h1 {
                font-size: 36px;
            }

            p {
                font-size: 18px;
            }
        }

        .section {
            padding: 40px 0;
        }

        .section-title {
            font-size: 32px;
        }

        .terms-article h3 {
            font-size: 20px;
        }
    }

    @media (max-width: 576px) {
        .tech-terms-banner {
            height: 250px;

            h1 {
                font-size: 28px;
            }

            p {
                font-size: 16px;
            }
        }

        .section-title {
            font-size: 28px;
        }

        .terms-accept .tech-confirm-btn {
            width: 100%;
        }
    }
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-20px);
    }
}
</style>
